<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('pages.login.resetPassword.title') }}</h4>
                  <p>{{ $t('pages.login.resetPassword.subtitle') }}</p>
                </div>

                <validation-observer ref="resetForm" v-slot="{ invalid }" slim>
                  <div>
                    <validation-provider vid="email" name="email" rules="required|email" v-slot="{ errors, failed, validate }" slim>
                      <div class="w-full">
                        <vs-input vid="email" type="text" icon-no-border icon="icon icon-user" icon-pack="feather"
                                  :label-placeholder="$t('fields.email')" @input="validate"
                                  v-model="email" :warning="failed"
                                  class="w-full"/>
                        <bds-error :text_error="errors[0]"/>
                      </div>
                    </validation-provider>

                    <validation-provider vid="password1" name="password1" rules="required|password" v-slot="{ errors, failed, validate }" slim>
                      <div class="w-full mt-2">
                        <vs-input type="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                                  :label-placeholder="$t('fields.password')"
                                  @input="validate" :warning="failed"
                                  v-model="password1" class="w-full"/>
                        <bds-error :text_error="errors[0]"/>
                      </div>
                    </validation-provider>

                    <validation-provider vid="password2" name="password2" rules="required|confirmed:password1" v-slot="{ errors, failed, validate }" slim>
                      <div class="w-full mt-2">
                        <vs-input type="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                                  :label-placeholder="$t('fields.password2')"
                                  @input="validate" :warning="failed"
                                  v-model="password2" class="w-full"/>
                        <bds-error :text_error="errors[0]"/>
                      </div>
                    </validation-provider>
                  </div>

                  <div class="w-full flex justify-between space-x-2 pt-2">
                    <vs-button type="border" color="warning" :to="{ name: 'login' }" class="w-full">
                      {{ $t('buttons.backLogin') }}
                    </vs-button>
                    <vs-button class="w-full" @click="submitResetPassword" :disabled="invalid">
                      {{ $t('buttons.reset') }}
                    </vs-button>
                  </div>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/Auth.service";
import {showSuccessNotify, showErrorNotify } from "@/helpers/functionsHelpers";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: '',
      password1: '',
      password2: '',

      token: null
    }
  },
  methods: {
    submitResetPassword() {
      //https://stackoverflow.com/questions/3489460/how-to-get-visitors-location-i-e-country-using-geolocation

      let registerFunc = (coordinates) => {
        const payload = {
          token: this.$route.params.token,
          email: this.email,
          password1: this.password1,
          password2: this.password2,
          lat: coordinates.lat || null,
          lng: coordinates.lng || null,
          accuracy: coordinates.accuracy || null
        }

        AuthService.resetPassword(payload).then((response) => {
          if (response.error) {
            this.$refs.resetForm.setErrors({
              password1: response.message,
            });
          } else {
            showSuccessNotify(this, this.$t('pages.login.resetPassword.success'));
            this.$router.push({name: 'login'})
          }
        }, (error) => {
          showErrorNotify(this, error);
        });
      }

      this.$getLocation().then((coordinates) => {
        console.log(coordinates);
        registerFunc(coordinates)
      }, (error) => {
        console.log(error);
        registerFunc({});
      });
    }
  },
}
</script>
